import { createSlice } from '@reduxjs/toolkit';
import DataExportsAPI from '~/api/data-exports-api';
import DataExportStatusConstants from '~/constants/data-export-status-constants';
import createCaughtAsyncThunk from '~/utils/create-action/create-caught-async-thunk';
import { addDataExportCasesToBuilder } from '../../reducer-utils';
import {
  defaultState,
  prependExportToHistory,
} from '../../data/DataExportCardState';

export const exportMachineUsageData = createCaughtAsyncThunk<
  any,
  { from: string; to: string }
>('exportMachineUsageData', async (args) => {
  return DataExportsAPI.exportMachineUsage(args.from, args.to);
});

export const getMachineUsageDataExportStatus = createCaughtAsyncThunk<
  any,
  string
>('getMachineUsageDataExportStatus', async (id, thunkAPI) => {
  const response = await DataExportsAPI.getExportStatus(id);
  if (response.status === DataExportStatusConstants.CREATED) {
    thunkAPI.dispatch(prependToHistory(response));
  }
  return response;
});

const slice = createSlice({
  name: 'data-exports-machine-usage',
  initialState: defaultState,
  reducers: {
    prependToHistory: (state, action) => {
      state.exportHistory = prependExportToHistory(
        state.exportHistory,
        action.payload
      );
    },
  },
  extraReducers: (builder) => {
    addDataExportCasesToBuilder(
      builder,
      'machineUsage',
      exportMachineUsageData,
      getMachineUsageDataExportStatus
    );
  },
});

export const { prependToHistory } = slice.actions;
export default slice.reducer;
